import React from "react";
import { EditCommentDialogState } from "../types";

interface DeleteConfirmDialogProps {
  editCommentDialog: EditCommentDialogState;
  setEditCommentDialog: React.Dispatch<
    React.SetStateAction<EditCommentDialogState>
  >;
  handleDeleteComment: (commentId: string) => void;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  editCommentDialog,
  setEditCommentDialog,
  handleDeleteComment,
}) => {
  if (!editCommentDialog.showDeleteConfirm) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-bold mb-4">Confirm Delete</h3>
        <p className="text-gray-700 mb-4">
          Are you sure you want to delete this comment? This action cannot be
          undone.
        </p>
        <div className="flex gap-2">
          <button
            className="flex-1 bg-red-600 text-white py-2 px-4 rounded hover:bg-red-700"
            onClick={() =>
              editCommentDialog.selectedComment &&
              handleDeleteComment(editCommentDialog.selectedComment.id)
            }
            disabled={editCommentDialog.isLoading}
          >
            {editCommentDialog.isLoading ? "Deleting..." : "Delete"}
          </button>
          <button
            className="flex-1 bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600"
            onClick={() =>
              setEditCommentDialog((prev) => ({
                ...prev,
                showDeleteConfirm: false,
                selectedComment: undefined,
              }))
            }
            disabled={editCommentDialog.isLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
